
<div>
  <div v-if="board">
    <page-header>
      <div class="categories ml-3 flex-1 text-nowrap d-flex">
        <div class="boardTitle mr-4 ml-2 font-weight-bold align-self-center">
          {{ board.title }}
        </div>

        <!-- Add Task -->
        <template-selector
          v-if="board"
          class="align-self-center"
          :board-guid="board.id"
          :disabled="addingTaskFromTemplate"
          @add-blank="addTask"
          @select="addTaskFromTemplate"
        />

        <!-- Filters -->
        <div class="d-flex flex-column">
          <!-- Board items Filter -->
          <div>
            <div
              class="badgebutton ml-4"
              :class="selectedCategories.length === 0 && !displayIsRelevantTasksOnly ? 'active' : ''"
              @click="chooseCategory('all')"
            >
              All
            </div>
            <div
              class="badgebutton ml-2"
              :class="selectedCategories.indexOf(category.id) !== -1 ? 'active' : ''"
              v-for="category in boardStore.availableCategories"
              :key="category.id"
              @click="chooseCategory(category.id)"
            >
              {{ category.name }}
            </div>
          </div>

          <!-- Special Occurrence filter -->
          <div class="mt-2 justify-content-start" v-if="availableSpecialOccurrences && availableSpecialOccurrences.length">
            <div
              class="badgebutton ml-4 color-white"
              :class="selectedOcurrences.length === 0 ? 'secondary' : ''"
              @click="chooseOccurrence()"
            >
              <i class="far fa-filter"></i>
              No filter
            </div>
            <div
              class="badgebutton ml-2 color-white"
              :class="selectedOcurrences.length === availableSpecialOccurrences.length ? 'secondary' : ''"
              @click="chooseOccurrence(-1)"
            >
              <i class="far fa-filter"></i>
              Select all
            </div>
            <div class="badgebutton ml-2 color-white" :class="selectNone ? 'secondary' : ''" @click="toggleSelectNone()">
              <i class="far fa-filter"></i>
              Select none
            </div>
            <div
              class="badgebutton ml-2 color-white"
              :class="selectedOcurrences.indexOf(occ.id) !== -1 ? 'secondary' : ''"
              v-for="occ in availableSpecialOccurrences"
              :key="occ.id"
              @click="chooseOccurrence(occ.id)"
            >
              {{ occ.name }}
            </div>
          </div>
        </div>

        <div class="d-flex flex-column">
          <div>
            <div class="ml-4 mr-2 align-self-center">
              <div class="d-flex justify-content-left">
                <div v-for="label in selectedLabels" :key="label.id">
                  <div
                    class="mr-2 d-flex justify-content-between align-items-center"
                    :style="{
                      'background-color': label.color,
                      color: 'white',
                      padding: '2px 5px',
                      'border-radius': '3px',
                      'font-size': '1rem',
                    }"
                  >
                    <i v-if="label.icon" :class="label.icon" class="mr-1 ml-1"></i>
                    {{ label.title }}
                    <div>
                      <i class="ml-2 fas fa-times cursor-pointer" @click="removeLabel(label)"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="selectedUser">
            <div class="ml-4 mt-2 mr-2 align-self-center">
              <div class="d-flex justify-content-left cursor-pointer" v-on:click="selectedUser = null">
                <div class="avatar avatar-xs d-flex align-items-center">
                  <span>{{ selectedUser.shortName.substr(0, 3) }}</span>
                  <div>
                    <i style="color: #333" class="ml-2 fas fa-times"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <template v-slot:right>
        <div class="mr-4 d-flex align-items-center">
          <div
            class="badgebutton ml-2"
            :class="displayIsRelevantTasksOnly ? 'active' : '' ? 'active' : ''"
            @click="processIsRelevantFilter()"
          >
            Report Relevant
          </div>
        </div>
        <div class="mr-4 d-flex align-items-center">
          <!-- Search -->
          <div class="input-group input-group-sm ml-2 mr-3 text-nowrap">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="far fa-search"></i>
              </span>
            </div>
            <input type="text" v-model="searchString" class="form-control" placeholder="Search..." aria-label="Username" />
          </div>

          <div class="currentShift" v-if="boardStore.board.enableShifts">
            <div>Current Shift</div>
            <div v-if="boardStore.board.currentShift">
              {{ currentShiftFrom | formatDateTime }}
              <br />
              {{ currentShiftTo | formatDateTime }}
            </div>
            <div v-else>NO SHIFT</div>
          </div>

          <div v-if="boardStore.board.enableShifts">
            <div v-if="showShiftPreparation" class="badgebutton success text-nowrap" @click="confirmShiftPreparation">
              Finalize Shift Handover
            </div>
            <div v-else class="badgebutton success active text-nowrap" @click="showModal('shiftHandover')">Handover to next Shift</div>
          </div>

          <router-link
            tag="div"
            :to="{
              name: 'shifts-overview',
              params: { id: boardStore.currentBoardId },
            }"
            v-if="boardStore.board.enableShifts"
            class="badgebutton active text-nowrap c-white ml-2"
          >
            <i class="far fa-clock"></i>
            Shifts Overview
          </router-link>

          <router-link
            tag="div"
            :to="{
              name: 'board-overview',
              params: { id: boardStore.currentBoardId },
            }"
            class="badgebutton active text-nowrap c-white ml-2"
          >
            <i class="far fa-clock"></i>
            Board Overview
          </router-link>

          <div class="badgebutton danger active text-nowrap ml-2" v-if="userStore.user.isAdmin" @click="confirmCleanup">
            <i class="far fa-broom"></i>
            Cleanup board
          </div>

          <div class="badgebutton danger active text-nowrap ml-2" v-if="canArchiveDone" @click="confirmArchiveDone">
            <i class="far fa-broom"></i>
            Archive done
          </div>

          <router-link
            v-if="currentUserIsBoardAdmin"
            tag="div"
            :to="{
              name: routes.settings,
              params: { id: boardStore.currentBoardId },
            }"
            class="badgebutton info active text-nowrap ml-2"
          >
            <i class="far fa-cogs"></i>
          </router-link>

          <router-link
            tag="div"
            :to="{
              name: routes.labels.statistic.name,
              params: { id: boardStore.currentBoardId },
            }"
            class="badgebutton info active text-nowrap ml-2 mr-2"
          >
            <i class="fa fa-tags"></i>
          </router-link>

          <div v-if="board && board.title && board.title.toLowerCase() === 'moc'">
            <div class="badgebutton info active text-nowrap ml-2" id="po">
              <i class="far fa-info-circle"></i>
              Due Dates
            </div>
            <b-popover target="po" triggers="hover" placement="bottom">
              <template #title>Due Date calculator</template>
              <moc-due-date-calculator></moc-due-date-calculator>
            </b-popover>
          </div>

          <div class="badgebutton" @click="demo(0)" v-if="displayDemoButtons">[1]</div>
          <div class="badgebutton" @click="demo(1)" v-if="displayDemoButtons">[2]</div>
        </div>
      </template>
    </page-header>

    <div class="d-flex">
      <div
        class="bahn"
        v-for="list in orderedLists"
        :key="list.id"
        :class="[
          list.listGroupType === ListGroupType.Delegated || list.listGroupType === ListGroupType.Shared ? 'ml-auto' : '',
          list.listGroupType === ListGroupType.Information ? 'information' : '',
        ]"
      >
        <div class="headers">
          <span class="pl-2 all-info" @click="showAllInfo = !showAllInfo">
            <span v-if="showAllInfoBtn(list)">
              <i v-b-tooltip.hover title="Hide old information items" v-if="showAllInfo" class="far fa-eye-slash"></i>
              <i v-b-tooltip.hover title="Show all information items" v-else class="far fa-eye"></i>
            </span>
          </span>

          {{ list.name }}
          <span v-on:click="toggleList(list.id)" class="arrow pr-2">
            <i v-if="isListToggled(list.id)" class="far fa-plus"></i>
            <i v-else class="far fa-minus"></i>
          </span>
        </div>

        <div class="containers">
          <div v-if="list.listGroupType === ListGroupType.Information" class="dnd-disabled">
            <s-o-card v-for="so in boardOccurrences" :item="so" :key="so.id"></s-o-card>
          </div>

          <Container
            :group-name="list.listGroup"
            :key="list.id"
            @drop="(e) => onDrop(list, e)"
            @drag-start="(e) => onDrag(list.id, e)"
            non-drag-area-selector=".dnd-disabled"
            :get-child-payload="getChildPayload(list.id)"
            drag-class="card-ghost"
            drop-class="card-ghost-drop"
          >
            <Draggable v-for="item in filteredBoardItems(list)" :key="item.guid">
              <!-- Delegated items -->
              <div class="dnd-disabled" v-if="item.key && item.isGrouped && item.groupedItems.length && !isListToggled(list.id)">
                <div class="board-card d-flex justify-content-between">
                  <div class="pl-2">
                    {{ item.key.title }}
                  </div>

                  <span v-on:click="toggleList(item.key.id)" class="arrow pr-2">
                    <i v-if="isListToggled(item.key.id)" class="far fa-plus"></i>
                    <i v-else class="far fa-minus"></i>
                  </span>
                </div>
                <div v-if="!isListToggled(item.key.id)">
                  <div v-for="delegatedItem in item.groupedItems" :key="delegatedItem.key">
                    <task-card
                      :item="delegatedItem"
                      :list="list"
                      v-if="isValidItemDate(delegatedItem, list)"
                      class="dnd-disabled m-1"
                      :class="{
                        'd-none': isItemHidden(delegatedItem),
                      }"
                    ></task-card>
                  </div>
                </div>
              </div>

              <!-- Normal items -->
              <div v-if="!item.isGrouped">
                <div
                  class="timecard dnd-disabled"
                  v-if="item.isFix && list.displayShiftTime && !isListToggled(list.id)"
                  :class="item.isNextShift ? 'nextshift' : ''"
                  @click="toggleItems(item)"
                >
                  <div class="d-flex justify-content-between align-center">
                    <div>
                      <i class="far fa-clock"></i>
                      {{ item.title }}
                    </div>
                    <div v-if="countSeparatorItems(item) > 0 && toggledSeparators.indexOf(item.sortOrder) !== -1">
                      <span class="badge badge-warning">
                        {{ countSeparatorItems(item) }}
                      </span>
                    </div>
                  </div>
                </div>
                <div v-else>
                  <task-card
                    :item="item"
                    :list="list"
                    v-if="!isListToggled(list.id) && isValidItemDate(item, list)"
                    :class="{
                      'd-none': isItemHidden(item),
                      'dnd-disabled':
                        (item.isDelegated && list.listGroupType === ListGroupType.Delegated) ||
                        list.listGroupType === ListGroupType.Shared,
                    }"
                    class="m-1"
                  ></task-card>
                </div>
              </div>
            </Draggable>

            <transition name="fade">
              <div class="c-container" v-if="isListToggled(list.id)">Collapsed</div>
            </transition>
          </Container>
        </div>
      </div>
    </div>

    <router-view></router-view>

    <AppInfo />

    <b-modal ref="shiftHandover" id="shiftHandover" hide-header hide-footer size="wide" title="Shift Handover" body-class="modal-body-wo">
      <shift-handover></shift-handover>
    </b-modal>
  </div>

  <div v-else>
    <page-header>
      <div class="badgebutton active text-nowrap c-white ml-4">
        <router-link class="mt-3 mb-2" :to="{ name: 'Boards' }">Back to Board list</router-link>
      </div>
    </page-header>

    <div class="d-flex align-items-center justify-content-center mt-4">
      <div class="no-access-error">This board does not exist or you are not authorized for this board</div>
    </div>
  </div>

  <b-modal id="delegate-to" ref="delegate-to" hide-header hide-footer title="Delegate to" body-class="modal-body-wo" size="m">
    <modal-window :main-width="12">
      <div class="delegate-modal-content">
        <h1 class="mb-4">Delegate to</h1>

        <div v-for="board in allboardsExceptCurrent" :key="board.id">
          <button class="btn btn-block btn-sm btn-success mt-2 mb-2" @click="delegate(board)">
            <i class="fas fa-share icon-left"></i>
            {{ board.title }}
          </button>
        </div>

        <b-button
          class="btn btn-block btn-sm mt-4"
          variant="outline-danger"
          block
          @click="
            itemIdToDelegate = '';
            $refs['delegate-to'].hide();
          "
        >
          Cancel
        </b-button>
      </div>
    </modal-window>
  </b-modal>

  <b-modal
    id="proccess-future-item"
    ref="proccess-future-item"
    hide-header
    hide-footer
    title="Specify Planned date"
    body-class="modal-body-wo"
    size="m"
  >
    <modal-window :main-width="12">
      <div class="proccess-future-item">
        <h1 class="mb-4">Select Planned Date</h1>

        <board-item-date-picker v-model="boardItemPlannedDate"></board-item-date-picker>

        <div class="d-flex justify-content-between">
          <b-button
            :disabled="!boardItemPlannedDate"
            class="btn btn-block btn-sm mt-4 mr-2"
            variant="success"
            block
            @click="endDropFutureBoardItem()"
          >
            Save
          </b-button>
          <b-button class="btn btn-block btn-sm mt-4 ml-2" variant="danger" block @click="cancelDropFutureBoardItem()">Cancel</b-button>
        </div>
      </div>
    </modal-window>
  </b-modal>

  <b-modal id="reject-delegate" ref="reject-delegate" hide-header hide-footer body-class="modal-body-wo" size="m">
    <modal-window :main-width="12">
      <div class="delegate-modal-content">
        <h1 class="mb-4">Delegate to</h1>

        <span>
          You are not allowed to delegate already delegated items. If you want to give this item back to the delegator, please open the
          item and click on 'Reject / Give back'
        </span>

        <b-button class="btn btn-block btn-sm mt-4" variant="outline-success" block @click="$refs['reject-delegate'].hide()">Ok</b-button>
      </div>
    </modal-window>
  </b-modal>
</div>
